import EzController from 'controllers/ez-base-controller';
import { triggerCustomEvent } from 'lib/helpers';
import Cookies from 'js-cookie';
import events from 'lib/events';
import axios from 'axios';

export default class GoogleOneTapController extends EzController {
  connect() {
    this.clientId = this.element.dataset.clientId;

    window.google.accounts.id.initialize({
      client_id: this.clientId,
      callback: this.handleCredentialResponse,
      context: this.element.dataset.context,
      state_cookie_domain: this.element.dataset.stateCookieDomain,
      auto_select: this.element.dataset.autoSelect,
    });

    window.google.accounts.id.prompt();
  }

  handleCredentialResponse = (response) => {
    const url = this.element.dataset.loginUri;

    Cookies.set('g_csrf_token', this.csrfToken);

    axios.defaults.headers.common['X-CSRF-Token'] = this.csrfToken;
    axios.post(`${url}?credential=${response.credential}&g_csrf_token=${this.csrfToken}`, response).then((req) => {
      if (req.status === 200) {
        // using the content type header to check if it's javascript
        // the google login/signup normally uses html content-type, but
        // we force javascript on signups so we can display the signup survey modal
        if (req.headers['content-type'] === 'text/javascript; charset=utf-8') {
          triggerCustomEvent(events.sessions.social.create_account_with_google);

          // we have to eval the modal injector code coming back
          eval(req.data); // eslint-disable-line no-eval
        } else {
          triggerCustomEvent(events.sessions.social.login_with_google);
          window.location.assign(req.request.responseURL);
        }
      }
    });
  }
}
